// extracted by mini-css-extract-plugin
export default {"summaryTable":"Checkout_summaryTable__MCGQu","enterInv":"Checkout_enterInv__19nVa","page":"Checkout_page__FL5Qb","centerAlign":"Checkout_centerAlign__pilNQ"};